import React from "react";
var __jsx = React.createElement;
import { createPortal } from "react-dom";
import { ModalManager, Screen } from './index';
var BottomSheet = function BottomSheet(_ref) {
  var open = _ref.open,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    screens = _ref.screens,
    _ref$modalDesign = _ref.modalDesign,
    modalDesign = _ref$modalDesign === void 0 ? {} : _ref$modalDesign,
    customClassName = _ref.customClassName,
    _ref$haveClose = _ref.haveClose,
    haveClose = _ref$haveClose === void 0 ? true : _ref$haveClose,
    _ref$hideTitleBar = _ref.hideTitleBar,
    hideTitleBar = _ref$hideTitleBar === void 0 ? false : _ref$hideTitleBar,
    _ref$hideCloseButton = _ref.hideCloseButton,
    hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? '' : _ref$maxHeight,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? '' : _ref$maxWidth,
    _ref$maxHeightDesktop = _ref.maxHeightDesktop,
    maxHeightDesktop = _ref$maxHeightDesktop === void 0 ? '' : _ref$maxHeightDesktop,
    _ref$maxWidthDesktop = _ref.maxWidthDesktop,
    maxWidthDesktop = _ref$maxWidthDesktop === void 0 ? '' : _ref$maxWidthDesktop,
    _ref$zeroHeightHead = _ref.zeroHeightHead,
    zeroHeightHead = _ref$zeroHeightHead === void 0 ? false : _ref$zeroHeightHead;
  if (!open) return null;
  return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(ModalManager, {
    open: open,
    onOpen: onOpen,
    onClose: onClose,
    screens: screens,
    modalDesign: modalDesign,
    customClassName: customClassName,
    haveClose: hideCloseButton ? false : haveClose,
    hideTitleBar: hideTitleBar,
    maxHeight: maxHeight,
    zeroHeightHead: zeroHeightHead,
    maxWidth: maxWidth,
    maxHeightDesktop: maxHeightDesktop,
    maxWidthDesktop: maxWidthDesktop
  }, screens.map(function (screen, index) {
    return /*#__PURE__*/React.createElement(Screen, {
      key: "screen-number-".concat(index),
      screenIndex: index + 1
    }, screen.component);
  })), document.body);
};
export default BottomSheet;